import { ContentViewModel } from '@levelapp/softfabric';
export default class StepViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.initialState({ currentPage: 0 });
        this.onPress = this.onPress.bind(this);
        this.goLeft = this.goLeft.bind(this);
        this.goRight = this.goRight.bind(this);
    }
    getCurrentPage() {
        if (this.state().currentPage != this.props().currentPage) {
            this.setField({ currentPage: this.props().currentPage });
            return this.props().currentPage;
        }
        else {
            return this.state().currentPage;
        }
    }
    onPress(key) {
        if (this.state().currentPage != key) {
            this.setField({ currentPage: key }, () => { this.props().handleChangingPage(this.state().currentPage); });
        }
    }
    goLeft() {
        //Can't occur
        if (this.state().currentPage == 0) {
            return;
        }
        this.setField({ currentPage: this.state().currentPage - 1 }, () => { this.props().handleChangingPage(this.state().currentPage); });
    }
    goRight() {
        //Can't occur
        if (this.state().currentPage == this.props().numberDisplays - 1) {
            return;
        }
        this.setField({ currentPage: this.state().currentPage + 1 }, () => { this.props().handleChangingPage(this.state().currentPage); });
    }
}
